<script lang="ts" setup>
  import { ref, onMounted, type PropType, type Ref, onBeforeUnmount, onUpdated } from 'vue';
  import type { SwiperOptions } from 'swiper/types';
  import type { NavButtons } from '@storefront/types';
  import Swiper from 'swiper';
  import { Navigation } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/navigation';

  const props = defineProps({
    posts: { type: Array, require: true },
    parameters: { type: Object as PropType<SwiperOptions>, required: false, default: {} },
    articleHeader: { type: String, default: 'h3', require: false },
    horizontal: { type: Boolean, default: false, required: false },
  });

  const htmlElement = ref() as Ref<HTMLElement>;
  const htmlNavigation = ref() as Ref<NavButtons>;
  const swiper = ref() as Ref<Swiper>;

  function initializeSwipers() {
    swiper.value = new Swiper(htmlElement.value, {
      spaceBetween: 16,
      ...props.parameters,
      modules: [Navigation],
      navigation: {
        nextEl: htmlNavigation.value.next.htmlElement,
        prevEl: htmlNavigation.value.prev.htmlElement,
      },
    });
  }

  function destroySwipers() {
    swiper.value?.destroy();
  }

  onMounted(() => {
    initializeSwipers();
  });

  onBeforeUnmount(() => {
    destroySwipers();
  });

  onUpdated(() => {
    initializeSwipers();
  });

  onBeforeUnmount(() => {
    destroySwipers();
  });
</script>
<template>
  <div class="items-carousel articles-carousel">
    <div ref="htmlElement" class="swiper items-carousel__container articles-carousel__container">
      <div class="swiper-wrapper">
        <div v-for="post in posts" class="swiper-slide items-carousel__slide articles-carousel__article">
          <SiteArticle :header="articleHeader" :horizontal :post />
        </div>
      </div>
    </div>
    <SfCarouselButtons ref="htmlNavigation" />
  </div>
</template>
<style lang="scss">
  :root {
    --sf-articles-carousel-padding: 0;
    --sf-articles-carousel-container-padding: 0;
  }

  .articles-carousel {
    padding: var(--sf-articles-carousel-padding);

    &__container {
      padding: var(--sf-articles-carousel-container-padding);
    }
  }
</style>
